import React from "react";
import { BackButtonStyled } from "./style";
var ButtonBack = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(BackButtonStyled, { onClick: onClick },
        React.createElement("svg", { width: "27", height: "14", viewBox: "0 0 27 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M7.86475 12.7783L2.10363 7.0172L7.86475 1.25609", stroke: "#5E2F87", strokeWidth: "1.78736", strokeLinecap: "round" }),
            React.createElement("path", { d: "M26.3398 7.15527L2.46622 7.15527", stroke: "#5E2F87", strokeWidth: "1.78736" })),
        React.createElement("p", null, " Volver")));
};
export default ButtonBack;
